module.exports = __webpack_public_path__ + "img/kanuri.b36d80c0.svg";